import React, { Component } from "react";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import AuthApi from "../../Services/Authapi";
import TableComponent from "../../Layouts/TableComponent";
import Breadcrumb from "../../Layouts/Breadcrumb";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import swal from "sweetalert";
import { ThemeContext } from "../../../ThemeContext";
import ls from "local-storage";
import IconButton from "@material-ui/core/IconButton";
import AuthCheckComponent from "../../Layouts/Token";
import Select from "@material-ui/core/Select";
import { withRouter } from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
import Tooltip from "@material-ui/core/Tooltip";
import FontAwesomeIconComponent from "../../Layouts/FontAwesomeIconComponent";
import Checkbox from "@material-ui/core/Checkbox";
import "./Ticket.css"
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from 'moment';
// import { DatePicker } from "@mui/x-date-pickers";
import InputAdornment from '@mui/material/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import Paper from '@mui/material/Paper';
import { createSwalLoaderNode } from "../../Layouts/swalLoader";

class Ticket extends Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    this.state = {
      tickets: [],
      count: 0,
      searchQuery: "",
      suggestions: [],
      showApprovedDetailsPopup: false,
      showRejectedReason: false,
      rejectedReason: "",
      approvedTickets: {},
      selectedTickets: [],
      selectedBulkAction: "",
      selectedLeaveDetails: null,
      showModalFromNotification: false,
      filterStatus: ["All"],
      allSelected: false,
      tableTh: [
        {
          id: "select",
          numeric: false,
          disablePadding: true,
          label: (
            <div className="wrap-check-20">
              <label>
                <input
                  type="checkbox"
                  checked={this.isAllSelected()}
                  onChange={this.handleSelectAllTickets}
                />
                <span className="checkbox"></span>
              </label>
            </div>
          ),
          sortable: false,
          style: { width: "40px" },
        },
        {
          id: "firstName",
          numeric: false,
          disablePadding: true,
          label: "Name",
          sortable: true,
          style: { width: "130px" },
        },
        {
          id: "leaveType",
          numeric: false,
          disablePadding: true,
          label: " Leave Type",
          sortable: true,
          style: { width: "130px" },
        },
        {
          id: "date_range",
          numeric: false,
          disablePadding: true,
          label: "Date Range",
          sortable: true,
          style: { width: "160px" },
        },
        {
          id: "no_of_days",
          numeric: false,
          disablePadding: true,
          label: "No Of Days",
          sortable: true,
          style: { width: "60px" },
        },
        {
          id: "ticket_mesasge",
          numeric: false,
          disablePadding: true,
          label: "Reason For Leave",
          sortable: false,
          style: { width: "100px" },
        },
        {
          id: "status",
          numeric: false,
          disablePadding: true,
          label: "Status",
          sortable: false,
          style: { width: "110px" },
        },

        {
          id: "created_at",
          numeric: false,
          disablePadding: true,
          label: "Created On",
          sortable: true,
          style: { width: "130px" },
        },
        {
          id: "updated_at",
          numeric: false,
          disablePadding: true,
          label: "Updated",
          sortable: true,
          style: { width: "130px" },
        },
        {
          id: "action",
          numeric: false,
          disablePadding: true,
          label: "Action",
          sortable: false,
          style: { width: "80px" },
        },
      ],
      loading: false,
      isTableLoading: true,
      rejectedTickets: {},
      selectedMonth: "",
      filteredLeave: [],
      startDate: null,
      endDate: null,
      expandedMessages: {},
      isReasonExpanded: false,
      page: 0,
      rowsPerPage: 10,
      showFilterModal: false, // <-- add this
      // Add modal filter states
      modalSelectedMonth: "",
      modalStartDate: null,
      modalEndDate: null,
      modalFilterStatus: ["All"],
    };

    this.ticketsData = this.ticketsData.bind(this);
    this.updateLeaveStatus = this.updateLeaveStatus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleSelectTicket = this.handleSelectTicket.bind(this);
    this.handleSelectAllTickets = this.handleSelectAllTickets.bind(this);
    this.bulkApprove = this.bulkApprove.bind(this);
    this.bulkCancel = this.bulkCancel.bind(this);
    this.bulkDelete = this.bulkDelete.bind(this);
    this.handleBulkActionChange = this.handleBulkActionChange.bind(this);
    this.handleBulkActionGo = this.handleBulkActionGo.bind(this);
    this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.toggleMessageExpansion = this.toggleMessageExpansion.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onRowsPerPageChange = this.onRowsPerPageChange.bind(this);
  }

  componentDidMount() {
    if (!this.props.authToken) {
      // this.props.history.push("/login");
    }
    this.ticketsData()
    const fromNotificationPanel = sessionStorage.getItem('fromNotificationPanel');
    if (this.props.location.state && this.props.location.state.notificationData && fromNotificationPanel) {
      const { dataId } = this.props.location.state.notificationData;
      this.fetchTicketDetails(dataId);
      this.setState({ showModalFromNotification: true });
      sessionStorage.removeItem('fromNotificationPanel');
    }

    const fromDashboard = sessionStorage.getItem('fromDashboard');
    if (this.props.location.state && this.props.location.state.leaveDetails && fromDashboard) {
      const { leaveDetails } = this.props.location.state;
      this.setState({ selectedLeaveDetails: leaveDetails, showApprovedDetailsPopup: true });
      sessionStorage.removeItem('fromDashboard');
    }

    // Apply default month filter after data is loaded
    // setTimeout(() => {
    //   this.filterTicketsByMonth();
    // }, 100);
  }

  ticketsData = async (props) => {
    this.setState({ isTableLoading: true });
    try {
      let tickets;
      const isAdmin = ls("roles") === "Super Admin";
      const isEmployeeRole = ls("roles") === "Employee";
      if (isAdmin) {
        tickets = await AuthApi.getTickets1();
      } else if (isEmployeeRole) {
        tickets = await AuthApi.getEmpLeaveticket();
      } else {
        tickets = await AuthApi.getEmpLeaveticket();
      }
      if (tickets && tickets.status === true) {
        const newarr = [];
        const ticketsData = tickets.data;
        ticketsData.forEach((element, key) => {
          const tempData = {
            id: element.id,
            user_id: element.user_id,
            firstName: element.firstName,
            leaveType: element.leaveType,
            date_range: element.date_range,
            no_of_days: element.no_of_days,
            ticket_mesasge: element.ticket_mesasge,
            status: element.status,
            cancel_reason: element.cancel_reason,
            c_reason: element.c_reason,
            created_at: element.created_at,
            updated_at: element.updated_at,
            firstleavetype: element.firstleavetype,
            secondleavetype: element.secondleavetype,
          };
          newarr.push(tempData);
        });
        const getStatusOrder = (status) => {
          const s = (status || "").toLowerCase().trim();
          if (s === "pending") return 1;
          if (s === "approved") return 2;
          if (s === "declined") return 3;
          if (s === "unapproved") return 4;
          if (s === "cancelled" || s === "canceled") return 5;
          return 6;
        };
        const pendingIndex = 1;
        const parseStartDate = (range) => {
          if (!range) return null;
          const [start] = range.split(/ to | To /i);
          const parsed = moment(start.trim(), "DD-MM-YYYY", true);
          return parsed.isValid() ? parsed : null;
        };

        const sortedTickets = newarr.sort((a, b) => {
          const orderA = getStatusOrder(a.status);
          const orderB = getStatusOrder(b.status);

          if (orderA !== orderB) {
            return orderA - orderB;
          }

          const dateA = parseStartDate(a.date_range);
          const dateB = parseStartDate(b.date_range);
          if (!dateA || !dateB) return 0;

          const isPendingGroup = orderA === pendingIndex;
          return isPendingGroup ? dateA.diff(dateB) : dateB.diff(dateA);
        });
        this.setState({
          tickets: sortedTickets,
          count: sortedTickets.length,
        }, () => {
          // Apply default month filter after tickets are loaded
          // this.filterTicketsByMonth();
        });
      } else {
        this.setState({
          tickets: [],
          count: 0,
        });
      }
    } catch (error) {
      console.error("Error fetching leave tickets:", error);
      this.setState({
        tickets: [],
        count: 0,
      });
    } finally {
      this.setState({ isTableLoading: false });
    }
  };

  fetchTicketDetails = async (dataId) => {
    try {
      const tickets = await AuthApi.getTickets1();
      if (tickets && tickets.status === true) {
        const ticket = tickets.data.find((ticket) => ticket.id === dataId);
        if (ticket) {
          this.setState({
            selectedLeaveDetails: ticket,
            showApprovedDetailsPopup: true,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching ticket details:", error);
    }
  };

  updateLeaveStatus(ticketId, newStatus, reason = "", isBulk = false) {
    if (newStatus === "Cancelled" && !reason) {
      swal({
        title: "Enter Reason",
        text: "Please enter the reason for cancelling the leave:",
        className: "leave-reason-swal",
        content: {
          element: "input",
          attributes: {
            placeholder: "Type your reason here",
            type: "text",
          },
        },
        buttons: {
          cancel: true,
          confirm: {
            text: "OK",
            closeModal: false,
          },
        },
      }).then((inputReason) => {
        if (!inputReason) {
          swal("Cancelled", "You need to write a reason!", "error");
          return;
        }
        this.updateLeaveStatus(ticketId, newStatus, inputReason, isBulk);
      });
      return;
    }

    if (newStatus === "Declined" && !reason) {
      swal({
        title: "Enter Reason",
        text: "Please enter the reason for declining the leave:",
        className: "leave-reason-swal",
        content: {
          element: "input",
          attributes: {
            placeholder: "Type your reason here",
            type: "text",
          },
        },
        buttons: {
          cancel: true,
          confirm: {
            text: "OK",
            closeModal: false,
          },
        },
      }).then((inputReason) => {
        if (!inputReason) {
          swal("Cancelled", "You need to write a reason!", "error");
          return;
        }
        this.updateLeaveStatus(ticketId, newStatus, inputReason, isBulk);
      });
      return;
    }

    if (!isBulk) {
      swal({
        title: `Confirm ${newStatus}`,
        text: `Are you sure you want to ${newStatus.toLowerCase()} this ticket?`,
        buttons: true,
        dangerMode: true,
      }).then((confirm) => {
        if (confirm) {
          swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            content: createSwalLoaderNode(),
          });
          this.updateLeave(ticketId, newStatus, reason);
        }
      });
    } else {
      swal({
        title: "Loading",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        content: createSwalLoaderNode(),
      });
      this.updateLeave(ticketId, newStatus, reason);
    }
  }

  updateLeave(ticketId, newStatus, reason) {
    const user = ls("user");
    const userName = `${user.firstName} ${user.lastName}`;
    const ticketUpdateData = {
      leaveStatus: newStatus,
      c_reason: newStatus === "Cancelled" ? reason : "",
      cancel_reason: newStatus !== "Cancelled" ? reason : "",
      updated_by: userName,
    };

    // Find the ticket to check its message before updating
    const { tickets } = this.state;
    const currentTicket = tickets.find(t => t.id === ticketId);

    AuthApi.updateTicketLeaveStatus(ticketUpdateData, ticketId)
      .then(async (response) => {
        if (response && response.status === true) {
          // Check if it's a "Pending Leave" being cancelled
          if (newStatus === "Cancelled" && currentTicket && currentTicket.ticket_mesasge === "Pending Leave") {
            try {
              // Automatically clock out the user if a mandatory pending leave is cancelled
              await AuthApi.outTime();
              swal("Success", "Pending leave cancelled. You have been clocked OUT.", "success").then(() => {
                window.location.reload();
              });
              return;
            } catch (err) {
              console.error("Auto checkout failed during leave cancellation:", err);
            }
          }

          swal("Success", "Ticket status updated successfully", "success").then(() => {
            window.location.reload();
          });
        } else {
          swal("Error", "Failed to update ticket status", "error");
        }
      })
      .catch((error) => {
        console.error("Error updating ticket status:", error);
        swal("Error", "Failed to update ticket status", "error");
      })
      .finally(() => {
        this.setState({ loading: false });
        swal.close();
        this.ticketsData();
      });

    const isApproved = newStatus === "Approved";
    const rejected = newStatus === "Declined";
    this.setState((prevState) => ({
      rejectedTickets: {
        ...prevState.rejectedTickets,
        [ticketId]: rejected ? reason : "",
      },
      approvedTickets: {
        ...prevState.approvedTickets,
        [ticketId]: isApproved,
      },
    }));
  }

  handleChange(e) {
    const searchQuery = e.target.value;
    const query = searchQuery.toLowerCase();
    const suggestions = this.state.tickets.filter((item) => {
      const fields = [
        item.leaveType,
        item.date_range,
        item.no_of_days,
        item.firstName,
        item.ticket_mesasge,
        item.status,
        item.created_at,
      ];
      return fields.some((field) =>
        (field ? field.toString().toLowerCase() : "").includes(query)
      );
    });
    this.setState({ searchQuery, suggestions }, this.applyAllFilters);
  }

  handleCloseModal = () => {
    this.setState({ showApprovedDetailsPopup: false, showModalFromNotification: false });
  };

  handleSearch = () => {
    this.applyAllFilters();
  };

  clearSearch = () => {
    this.setState({ searchQuery: "", suggestions: [] }, this.applyAllFilters);
  };

  handleSuggestionClick = (suggestion) => {
    this.setState({ searchQuery: suggestion.firstName, suggestions: [] }, this.handleSearch);
  };

  handleSelectAllTickets = () => {
    const { page, rowsPerPage, tickets } = this.state;
    const currentPageTickets = tickets.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    const currentTicketIds = currentPageTickets.map(ticket => ticket.id);

    this.setState(prevState => {
      const newSelectedTickets = prevState.allSelected
        ? prevState.selectedTickets.filter(id => !currentTicketIds.includes(id))
        : [...new Set([...prevState.selectedTickets, ...currentTicketIds])];

      return {
        selectedTickets: newSelectedTickets,
        allSelected: !prevState.allSelected
      };
    });
  };

  handleSelectTicket = (ticketId) => {
    this.setState(prevState => {
      const selectedTickets = prevState.selectedTickets.includes(ticketId)
        ? prevState.selectedTickets.filter(id => id !== ticketId)
        : [...prevState.selectedTickets, ticketId];

      // Check if all current page tickets are selected
      const currentPageTickets = prevState.tickets.slice(
        prevState.page * prevState.rowsPerPage,
        (prevState.page + 1) * prevState.rowsPerPage
      );
      const allCurrentPageSelected = currentPageTickets.every(ticket =>
        selectedTickets.includes(ticket.id)
      );

      return {
        selectedTickets,
        allSelected: allCurrentPageSelected
      };
    });
  };

  isAllSelected = () => {
    const { tickets = [], selectedTickets = [] } = this.state || {};
    return tickets.length > 0 && tickets.every(ticket => selectedTickets.includes(ticket.id));
  };

  handleBulkActionChange(event) {
    this.setState({ selectedBulkAction: event.target.value });
  }

  handleBulkActionGo() {
    const { selectedBulkAction, selectedTickets, tickets, page, rowsPerPage } = this.state;

    // Get only the current page tickets that are selected
    const currentPageTickets = tickets.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    const validTickets = selectedTickets.filter(ticketId => {
      const ticket = currentPageTickets.find(t => t.id === ticketId);
      return ticket && !["Declined", "Cancelled", "Unapproved"].includes(ticket.status);
    });

    if (selectedBulkAction === "approve") {
      this.bulkApprove(validTickets);
    } else if (selectedBulkAction === "decline") {
      this.bulkDelete(validTickets);
    } else if (selectedBulkAction === "cancel") {
      this.bulkCancel(validTickets);
    }
  }

  bulkApprove(validTickets) {
    swal({
      title: "Confirm Bulk Approve",
      text: "Are you sure you want to approve the selected tickets?",
      buttons: true,
      dangerMode: true,
    }).then((confirm) => {
      if (confirm) {
        validTickets.forEach((ticketId) => {
          this.updateLeaveStatus(ticketId, "Approved", "", true);
        });
      }
    });
  }

  bulkCancel(validTickets) {
    swal({
      title: "Enter Reason",
      text: "Please enter the reason for cancelling the leave:",
      className: "leave-reason-swal",
      content: {
        element: "input",
        attributes: {
          placeholder: "Type your reason here",
          type: "text",
        },
      },
      buttons: {
        cancel: true,
        confirm: {
          text: "OK",
          closeModal: false,
        },
      },
    }).then((inputReason) => {
      if (!inputReason) {
        swal("Cancelled", "You need to write a reason!", "error");
        return;
      }
      swal({
        title: "Confirm Bulk Cancel",
        text: "Are you sure you want to cancel the selected tickets?",
        buttons: true,
        dangerMode: true,
      }).then((confirm) => {
        if (confirm) {
          validTickets.forEach((ticketId) => {
            this.updateLeaveStatus(ticketId, "Cancelled", inputReason, true);
          });
        }
      });
    });
  }

  bulkDelete(validTickets) {
    swal({
      title: "Enter Reason",
      text: "Please enter the reason for declining the leave:",
      className: "leave-reason-swal",
      content: {
        element: "input",
        attributes: {
          placeholder: "Type your reason here",
          type: "text",
        },
      },
      buttons: {
        cancel: true,
        confirm: {
          text: "OK",
          closeModal: false,
        },
      },
    }).then((inputReason) => {
      if (!inputReason) {
        swal("Cancelled", "You need to write a reason!", "error");
        return;
      }
      swal({
        title: "Confirm Bulk Decline",
        text: "Are you sure you want to decline the selected tickets?",
        buttons: true,
        dangerMode: true,
      }).then((confirm) => {
        if (confirm) {
          validTickets.forEach((ticketId) => {
            this.updateLeaveStatus(ticketId, "Declined", inputReason, true);
          });
        }
      });
    });
  }

  handleFilterChange(event) {
    const value = event.target.value;
    console.log("Selected value:", value);

    if (value[0] === "All" && value.length > 1) {

      const filteredValues = value.slice(1);
      this.setState({ filterStatus: filteredValues }, () => {
        // console.log("Filter status after update:", this.state.filterStatus); 
      });
    } else if (value.includes("All")) {
      this.setState({ filterStatus: ["All"] }, () => {
        // console.log("Filter status after update:", this.state.filterStatus); 
      });
    } else {
      this.setState({ filterStatus: value }, () => {
        // console.log("Filter status after update:", this.state.filterStatus); 
      });
    }
  }

  handleMonthChange(event) {
    this.setState({ selectedMonth: event.target.value }, this.applyAllFilters);
  }

  handleStartDateChange(date) {
    // If end date exists and is before the new start date, reset end date
    let newEndDate = this.state.endDate;
    if (date && this.state.endDate && this.state.endDate.isBefore(date)) {
      newEndDate = null;
    }

    this.setState({
      startDate: date,
      endDate: newEndDate
    }, this.applyAllFilters);
  }

  handleEndDateChange(date) {
    // Validate that end date is not before start date
    if (date && this.state.startDate && date.isBefore(this.state.startDate)) {
      swal("Invalid Date", "End date cannot be before start date", "error");
      return;
    }

    this.setState({ endDate: date }, this.applyAllFilters);
  }

  toggleMessageExpansion(ticketId) {
    this.setState((prevState) => ({
      expandedMessages: {
        ...prevState.expandedMessages,
        [ticketId]: !prevState.expandedMessages[ticketId],
      },
    }));
  }

  onPageChange = (newPage) => {
    this.setState({
      page: newPage,
      selectedTickets: [], // Reset selection
      allSelected: false
    });
  };

  onRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    this.setState({
      rowsPerPage: newRowsPerPage,
      page: 0, // Reset to first page
      selectedTickets: [], // Reset selection
      allSelected: false
    });
  };

  // When opening the modal, initialize modal filter state from main state
  openFilterModal = () => {
    this.setState({
      showFilterModal: true,
      modalSelectedMonth: this.state.selectedMonth,
      modalStartDate: this.state.startDate,
      modalEndDate: this.state.endDate,
      modalFilterStatus: [...this.state.filterStatus],
    });
  };

  // Modal filter change handlers
  handleModalMonthChange = (e) => {
    this.setState({ modalSelectedMonth: e.target.value });
  };
  handleModalStartDateChange = (e) => {
    const dateValue = e.target.value;
    const newStartDate = dateValue ? moment(dateValue, 'YYYY-MM-DD') : null;

    // If end date exists and is before the new start date, reset end date
    const proceedSettingStartDate = () => {
      let newEndDate = this.state.modalEndDate;
      if (newStartDate && this.state.modalEndDate && this.state.modalEndDate.isBefore(newStartDate)) {
        newEndDate = null;
      }
      this.setState({
        modalStartDate: newStartDate,
        modalEndDate: newEndDate
      });
    };

    if (this.state.modalSelectedMonth) {
      swal({
        title: "Clear Month/Year filter?",
        text: "To use Start/End Date, clear the Month/Year filter.",
        buttons: ["Cancel", "Clear and Continue"],
        dangerMode: true,
      }).then((willClear) => {
        if (willClear) {
          this.setState({ modalSelectedMonth: "" }, proceedSettingStartDate);
        }
      });
      return;
    }

    proceedSettingStartDate();
  };
  handleModalEndDateChange = (e) => {
    const dateValue = e.target.value;
    const newEndDate = dateValue ? moment(dateValue, 'YYYY-MM-DD') : null;

    // Validate that end date is not before start date
    const proceedSettingEndDate = () => {
      if (newEndDate && this.state.modalStartDate && newEndDate.isBefore(this.state.modalStartDate)) {
        swal("Invalid Date", "End date cannot be before start date", "error");
        return;
      }
      this.setState({ modalEndDate: newEndDate });
    };

    if (this.state.modalSelectedMonth) {
      swal({
        title: "Clear Month/Year filter?",
        text: "To use Start/End Date, clear the Month/Year filter.",
        buttons: ["Cancel", "Clear and Continue"],
        dangerMode: true,
      }).then((willClear) => {
        if (willClear) {
          this.setState({ modalSelectedMonth: "" }, proceedSettingEndDate);
        }
      });
      return;
    }

    proceedSettingEndDate();
  };
  handleModalFilterChange = (event) => {
    const value = event.target.value;
    if (value[0] === "All" && value.length > 1) {
      this.setState({ modalFilterStatus: value.slice(1) });
    } else if (value.includes("All")) {
      this.setState({ modalFilterStatus: ["All"] });
    } else {
      this.setState({ modalFilterStatus: value });
    }
  };

  // Add this function to apply all filters at once
  applyAllFilters = () => {
    let filtered = [...this.state.tickets];

    // Filter by month/year
    if (this.state.selectedMonth) {
      filtered = filtered.filter(ticket => {
        const [startDate] = ticket.date_range.split(' to ');
        const ticketMonth = moment(startDate, "DD-MM-YYYY").format('YYYY-MM');
        return ticketMonth === this.state.selectedMonth;
      });
    }

    // Filter by date range
    if (this.state.startDate && this.state.endDate) {
      filtered = filtered.filter(ticket => {
        const [startRange] = ticket.date_range.split(' to ');
        const ticketDate = moment(startRange, "DD-MM-YYYY");
        return ticketDate.isBetween(this.state.startDate, this.state.endDate, null, '[]');
      });
    }

    // Filter by status
    if (!this.state.filterStatus.includes("All")) {
      filtered = filtered.filter(ticket =>
        this.state.filterStatus.includes(ticket.status.toLowerCase())
      );
    }

    // Filter by search query
    if (this.state.searchQuery) {
      const query = this.state.searchQuery.toLowerCase();
      filtered = filtered.filter(item => {
        const fields = [
          item.leaveType,
          item.date_range,
          item.no_of_days,
          item.firstName,
          item.ticket_mesasge,
          item.status,
          item.created_at,
        ];
        return fields.some(field =>
          (field ? field.toString().toLowerCase() : "").includes(query)
        );
      });
    }

    this.setState({ filteredLeave: filtered });
  };

  // Add this function to count active filters
  getActiveFilterCount = () => {
    let count = 0;
    if (this.state.selectedMonth) count++;
    if (this.state.startDate || this.state.endDate) count++; // Only 1 for date range
    if (!this.state.filterStatus.includes("All")) count++;
    if (this.state.searchQuery) count++;
    return count;
  };

  render() {
    const { darkMode } = this.context;
    const classes = this.props;
    const hasActiveFilters =
      this.state.searchQuery ||
      this.state.selectedMonth ||
      this.state.startDate ||
      this.state.endDate ||
      !this.state.filterStatus.includes("All");
    const filteredLeave = hasActiveFilters ? this.state.filteredLeave : this.state.tickets;
    const isAdmin = ls("roles") === "Super Admin";
    const permissions = (this.props.authUser &&
      Array.isArray(this.props.authUser.userAccess))
      ? this.props.authUser.userAccess
      : [];
    const getStatusOrder = (status) => {
      const s = (status || "").toLowerCase().trim();
      if (s === "pending") return 1;
      if (s === "approved") return 2;
      if (s === "declined") return 3;
      if (s === "unapproved") return 4;
      if (s === "cancelled" || s === "canceled") return 5;
      return 6;
    };
    const pendingIndex = 1;
    const parseStartDate = (range) => {
      if (!range) return null;
      const [start] = range.split(/ to | To /i);
      const parsed = moment(start.trim(), "DD-MM-YYYY", true);
      return parsed.isValid() ? parsed : null;
    };

    const filteredAndSortedLeave = filteredLeave
      .filter(item => {
        if (this.state.filterStatus.includes("All")) return true;
        return this.state.filterStatus.includes(item.status.toLowerCase());
      })
      .sort((a, b) => {
        const orderA = getStatusOrder(a.status);
        const orderB = getStatusOrder(b.status);

        if (orderA !== orderB) {
          return orderA - orderB;
        }

        const dateA = parseStartDate(a.date_range);
        const dateB = parseStartDate(b.date_range);
        if (!dateA || !dateB) return 0;

        const isPendingGroup = orderA === pendingIndex;
        return isPendingGroup ? dateA.diff(dateB) : dateB.diff(dateA);
      });
    const userId = ls("user").id;

    return (
      <div>
        <AuthCheckComponent authToken={this.props.authToken} />
        <Header
          {...this.props}
          authUser={this.props.authUser}
          setAutUser={this.props.setAutUser}
          component={
            <div className="Ticketmodule" style={{ marginBottom: "11%" }}>
              <Card className={classes.root} style={{ marginBottom: "3%" }}>
                <CardContent>
                  <Breadcrumb
                    {...this.props}
                    primaryPageName="Leaves Ticket"
                    primaryPageLink="/leave-tickets"
                    isSecondaryPage={false}
                    secondaryPageName=""
                  />
                </CardContent>
              </Card>

              {/* Filter Modal */}
              <Dialog
                open={this.state.showFilterModal}
                onClose={() => this.setState({ showFilterModal: false })}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                  style: {
                    borderRadius: "8px",
                    padding: "0"
                  }
                }}
              >
                <DialogTitle style={{
                  backgroundColor: "#036dda",
                  color: "white",
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "bold",
                  position: "relative",
                  minHeight: "36px",
                  padding: "8px 0 8px 0",
                  lineHeight: 1.2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  Filter Tickets
                  <CloseIcon
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 10,
                      cursor: "pointer",
                      color: "#fff",
                      backgroundColor: "#f44336",
                      borderRadius: "50%",
                      padding: "2px",
                      width: 28,
                      height: 28
                    }}
                    onClick={() => this.setState({ showFilterModal: false })}
                  />
                </DialogTitle>
                <DialogContent className="leave-ticket-filter-content" style={{ padding: "24px" }}>
                  {/* Inline style for filter modal date fields */}
                  <style>{`
                    .filter-date-row {
                      display: flex;
                      gap: 8px;
                    }
                    .filter-date-row .filter-date-field {
                      width: 50%;
                    }
                  `}</style>
                  {/* Date Filters Section */}
                  <div style={{ marginBottom: "24px" }}>
                    <h3
                      style={{
                        margin: "0 0 16px 0",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#036dda",
                        borderBottom: darkMode ? "1px solid #555" : "1px solid #e0e0e0",
                        paddingBottom: "8px",
                      }}
                    >
                      Date Filters
                    </h3>
                    <TextField
                      id="datetime-local"
                      label="Select Month/Year"
                      variant="outlined"
                      type="month"
                      value={this.state.modalSelectedMonth}
                      onChange={this.handleModalMonthChange}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: "2000-01", max: new Date().toISOString().slice(0, 7) }}
                      fullWidth
                      style={{ marginBottom: 16, height: "56px" }}
                    />
                    <div className="filter-date-row">
                      <TextField
                        className="filter-date-field"
                        type="date"
                        label="Start Date"
                        value={this.state.modalStartDate ? moment(this.state.modalStartDate).format('YYYY-MM-DD') : ''}
                        onChange={(e) => this.handleModalStartDateChange(e)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          max: this.state.modalEndDate ? moment(this.state.modalEndDate).format('YYYY-MM-DD') : undefined
                        }}
                        style={{ marginBottom: 16, height: "56px", marginRight: 8 }}
                      />
                      <TextField
                        className="filter-date-field"
                        type="date"
                        label="End Date"
                        value={this.state.modalEndDate ? moment(this.state.modalEndDate).format('YYYY-MM-DD') : ''}
                        onChange={(e) => this.handleModalEndDateChange(e)}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          min: this.state.modalStartDate ? moment(this.state.modalStartDate).format('YYYY-MM-DD') : undefined
                        }}
                        style={{ marginBottom: 16, height: "56px", marginLeft: 8 }}
                      />
                    </div>
                  </div>

                  {/* Status Filter Section */}
                  <div style={{ marginBottom: "24px" }}>
                    <h3
                      style={{
                        margin: "0 0 16px 0",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#036dda",
                        borderBottom: darkMode
                          ? "1px solid #555"
                          : "1px solid #e0e0e0",
                        paddingBottom: "8px",
                      }}
                    >
                      Status Filter
                    </h3>
                    <FormControl fullWidth style={{ marginBottom: 16 }}>
                      <InputLabel id="filter-status-label">Filter Leave Status</InputLabel>
                      <Select
                        labelId="filter-status-label"
                        multiple
                        value={this.state.modalFilterStatus}
                        onChange={this.handleModalFilterChange}
                        renderValue={(selected) => selected.join(', ')}
                        style={{ height: "56px" }}
                        MenuProps={{
                          PaperProps: {
                            className: "leave-status-menu",
                          },
                        }}
                      >
                        <MenuItem value="All">
                          <Checkbox checked={this.state.modalFilterStatus.includes("All")} />
                          All
                        </MenuItem>
                        {["approved", "declined", "pending", "cancelled", "unapproved"].map(status => (
                          <MenuItem key={status} value={status}>
                            <Checkbox checked={this.state.modalFilterStatus.includes(status)} />
                            {status.charAt(0).toUpperCase() + status.slice(1)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  {/* Removed search TextField from modal */}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 12,
                    borderTop: "1px solid #e0e0e0",
                    paddingTop: "16px"
                  }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        this.setState({
                          selectedMonth: this.state.modalSelectedMonth,
                          startDate: this.state.modalStartDate,
                          endDate: this.state.modalEndDate,
                          filterStatus: [...this.state.modalFilterStatus],
                          showFilterModal: false,
                        }, this.applyAllFilters);
                      }}
                      style={{
                        minWidth: "100px",
                        backgroundColor: "#036dda",
                        textTransform: "none",
                        fontWeight: "600"
                      }}
                    >
                      Apply
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        this.setState({
                          selectedMonth: "",
                          startDate: null,
                          endDate: null,
                          filterStatus: ["All"],
                          modalSelectedMonth: "",
                          modalStartDate: null,
                          modalEndDate: null,
                          modalFilterStatus: ["All"],
                          searchQuery: "",
                          showFilterModal: false,
                        }, this.applyAllFilters);
                      }}
                      style={{
                        minWidth: "100px",
                        borderColor: "#036dda",
                        color: "#036dda",
                        textTransform: "none",
                        fontWeight: "600"
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                </DialogContent>
              </Dialog>

              <TableComponent
                {...this.props}
                modelName="Leaves Tickets"
                addRoute="/leave-tickets/add"
                orderBy="sortOrder"
                order="asc"
                selected={this.state.selectedTickets}
                setSelected={(selectedTickets) => this.setState({ selectedTickets })}
                page={this.state.page}
                rowsPerPage={this.state.rowsPerPage}
                onPageChange={this.onPageChange}
                onRowsPerPageChange={this.onRowsPerPageChange}
                handleSelectAllTickets={this.handleSelectAllTickets}
                handleSelectTicket={this.handleSelectTicket}
                allSelected={this.state.allSelected}
                extraHeaderContent={(
                  <>
                    <Tooltip title="Filter">
                      <Button
                        variant="contained"
                        color="primary"
                        className="common-action-button common-add-button"
                        onClick={this.openFilterModal}
                      >
                        <FilterListIcon style={{ marginRight: this.getActiveFilterCount() > 0 ? '4px' : '0' }} />
                        {this.getActiveFilterCount() > 0 && `(${this.getActiveFilterCount()})`}
                      </Button>
                    </Tooltip>

                    <div className="leave-ticket-search-wrap">
                      <TextField
                        label="Search"
                        value={this.state.searchQuery}
                        onChange={this.handleChange}
                        className="leave-ticket-search-field"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: this.state.searchQuery !== "",
                          style: {
                            color: "#036dda",
                            transform:
                              this.state.searchQuery !== ""
                                ? "translate(14px, -6px) scale(0.75)"
                                : "translate(14px, 11px) scale(1)",
                            transition: "transform 0.2s ease-in-out",
                          },
                        }}
                        InputProps={{
                          className: "leave-ticket-search-input",
                          endAdornment: (
                            <InputAdornment position="end">
                              {this.state.searchQuery && (
                                <ClearIcon
                                  onClick={this.clearSearch}
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                              <SearchIcon
                                onClick={this.handleSearch}
                                style={{ cursor: "pointer" }}
                              />
                            </InputAdornment>
                          ),
                        }}
                        inputProps={{
                          style: {
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          },
                          title: this.state.searchQuery,
                        }}
                      />
                      {this.state.searchQuery && this.state.suggestions.length > 0 && (
                        <Paper className="leave-ticket-search-suggestions">
                          {[...new Set(this.state.suggestions.map(suggestion => suggestion.firstName))].map((name, index) => (
                            <MenuItem
                              key={index}
                              onClick={() => this.handleSuggestionClick({ firstName: name })}
                              style={{
                                padding: '10px 20px',
                                cursor: 'pointer'
                              }}
                            >
                              {name}
                            </MenuItem>
                          ))}
                        </Paper>
                      )}
                    </div>
                  </>
                )}
                tableTh={this.state.tableTh.map((column) => {
                  if (column.id === "select") {
                    const currentPageTickets = this.state.tickets.slice(
                      this.state.page * this.state.rowsPerPage,
                      (this.state.page + 1) * this.state.rowsPerPage
                    );
                    const currentTicketIds = currentPageTickets.map(ticket => ticket.id);
                    const allCurrentPageSelected = currentTicketIds.every(id =>
                      this.state.selectedTickets.includes(id)
                    );

                    return {
                      ...column,
                      label: currentPageTickets.length > 0 ? (
                        <div className="wrap-check-20">
                          <label>
                            <input
                              type="checkbox"
                              checked={allCurrentPageSelected}
                              onChange={this.handleSelectAllTickets}
                            />
                            <span className="checkbox"></span>
                          </label>
                        </div>
                      ) : null,
                    };
                  }
                  return column;
                })}
                style={{ tableLayout: "fixed" }}
                bodyStyle={{ overflowX: "auto" }}
                wrapperStyle={{ width: "96%", margin: "0 auto" }}
                headerStyle={{ background: "transparent" }}
                tableData={filteredAndSortedLeave.map((item) => ({
                  ...item,
                  sortOrder: getStatusOrder(item.status),
                  date_range: (
                    <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
                      {item.date_range.replace(' to ', '\nto\n')}
                    </div>
                  ),
                  created_at: (
                    <div style={{ whiteSpace: 'pre-line' }}>
                      {item.created_at ? item.created_at.replace(' ', '\n') : '-'}
                    </div>
                  ),
                  updated_at: (
                    <div style={{ whiteSpace: 'pre-line' }}>
                      {item.updated_at ? item.updated_at.replace(' ', '\n') : '-'}
                    </div>
                  ),
                  select: (
                    <div className="wrap-check-20">
                      {["Declined", "Cancelled", "Unapproved"].includes(item.status) ? null : (
                        <label>
                          <input
                            type="checkbox"
                            checked={this.state.selectedTickets.includes(item.id)}
                            onChange={() => this.handleSelectTicket(item.id)}
                          />
                          <span className="checkbox"></span>
                        </label>
                      )}
                    </div>
                  ),
                  actions: (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "row",
                        }}
                      >
                        {(item.status === "Pending" && item.user_id !== userId) || (isAdmin && item.status === "Pending") ? (
                          <>
                            {permissions.includes("Leaveticket.Approve") && item.status !== "Approved" && (
                              <Tooltip title="Approve">
                                <IconButton
                                  onClick={() =>
                                    this.updateLeaveStatus(item.id, "Approved")
                                  }
                                  style={{ cursor: "pointer", padding: "2px" }}
                                  variant="contained"
                                  color="primary"
                                >
                                  <FontAwesomeIconComponent
                                    classes="far fa-check-square"
                                    style={{
                                      cursor: "pointer",
                                      color: "var(--hrms-primary-blue-end, #036dda)",
                                    }}
                                    fontSize={"small"}
                                  />
                                </IconButton>
                              </Tooltip>
                            )}

                            {permissions.includes("Leaveticket.Declined") && item.status === "Pending" && (
                              <Tooltip title="Declined">
                                <IconButton
                                  onClick={() =>
                                    this.updateLeaveStatus(item.id, "Declined")
                                  }
                                  variant="contained"
                                  color="primary"
                                  style={{ padding: "2px" }}
                                >
                                  <FontAwesomeIconComponent
                                    classes="fas fa-window-close"
                                    fontSize={"small"}
                                    style={{
                                      cursor: "pointer",
                                      color: "var(--hrms-primary-blue-end, #036dda)",
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                            )}

                            {permissions.includes("Leaveticket.Unapproved") && item.status === "Pending" && (
                              <Tooltip title="Unapproved">
                                <IconButton
                                  onClick={() =>
                                    this.updateLeaveStatus(item.id, "Unapproved")
                                  }
                                  variant="contained"
                                  color="secondary"
                                  style={{ padding: "2px" }}
                                >
                                  <FontAwesomeIconComponent
                                    classes="fas fa-times-circle"
                                    fontSize={"small"}
                                    style={{
                                      cursor: "pointer",
                                      color: "#ff0000",
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                            )}
                          </>
                        ) : null}
                      </div>

                      {item.status === "Pending" && item.user_id === userId &&
                        permissions.includes("Leaveticket.Edit") && (
                          <Tooltip title="Update">
                            <IconButton
                              onClick={() => {
                                this.props.history.push(
                                  `/leave-tickets/edit/${item.id}`
                                );
                              }}
                              variant="contained"
                              color="primary"
                              style={{ padding: "2px" }}
                            >
                              <FontAwesomeIconComponent
                                classes="fa fa-edit"
                                style={{ cursor: "pointer", color: "var(--hrms-primary-blue-end, #036dda)" }}
                                fontSize={"small"}
                              />
                            </IconButton>
                          </Tooltip>
                        )}

                      {permissions.includes("Leaveticket.Cancel") && ["Pending", "Approved"].includes(item.status) && (
                        <Tooltip title="Cancel Leave Request">
                          <IconButton
                            onClick={() => {
                              this.updateLeaveStatus(item.id, "Cancelled");
                            }}
                            variant="contained"
                            color="red"
                            style={{
                              padding: "2px",
                            }}
                          >
                            <FontAwesomeIconComponent
                              classes="fa fa-ban"
                              style={{
                                cursor: "pointer",
                                color: "#dc3545",
                              }}
                              fontSize={"small"}
                            />
                          </IconButton>
                        </Tooltip>
                      )}

                      {permissions.includes("Leaveticket.Viewdetails") && (
                        <Tooltip
                          title="View Details"
                          className="custom-tooltip"
                        >
                          <IconButton
                            onClick={() => {
                              if (
                                item.status === "Declined" &&
                                ls("roles") === "Employee"
                              ) {
                                this.setState({
                                  selectedLeaveDetails: item,
                                  rejectedReason: this.state.rejectedTickets[item.id],
                                  showRejectedReason: true,
                                  showApprovedDetailsPopup: true,
                                });
                              } else {
                                this.setState({
                                  selectedLeaveDetails: item,
                                  showApprovedDetailsPopup: true,
                                });
                              }
                            }}
                            variant="contained"
                            color="primary"
                            style={{ cursor: "pointer", padding: "2px" }}
                          >
                            <FontAwesomeIconComponent
                              classes="fa fa-info-circle"
                              style={{ color: "var(--hrms-primary-blue-end, #036dda)" }}
                              fontSize={"small"}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  ),
                  status: (
                    <div
                      style={{
                        display: 'inline-block',
                        backgroundColor:
                          item.status === "Approved" ? "#16a34a" :
                            item.status === "Declined" ? "#e4aaaaff" :
                              item.status === "Cancelled" ? "#eab308" :
                                item.status === "Unapproved" ? "#e34d4d" :
                                  "#e5e562ff",
                        color:
                          "#2a2a2a",
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontWeight: 'bold',
                        fontSize: '12px',
                        fontFamily: 'Arial, sans-serif',
                        minWidth: '90px',
                        width: 'auto',
                        textAlign: 'center',
                      }}
                    >
                      {this.state.approvedTickets[item.id]
                        ? "Completed"
                        : item.status}
                    </div>
                  ),
                  ticket_mesasge: (
                    <div>
                      {this.state.expandedMessages[item.id] || item.ticket_mesasge.length <= 50
                        ? item.ticket_mesasge
                        : `${item.ticket_mesasge.substring(0, 50)}...`}
                      {item.ticket_mesasge.length > 50 && (
                        <span
                          onClick={() => this.toggleMessageExpansion(item.id)}
                          style={{ color: '#036dda', cursor: 'pointer', marginLeft: '5px', display: 'inline-block' }}
                        >
                          {this.state.expandedMessages[item.id] ? 'Read Less' : 'Read More'}
                        </span>
                      )}
                    </div>
                  ),
                }))}




                // rowStyle={(item) => ({
                //   backgroundColor:
                //     item.status === "Approved"
                //       ? "#c7f1c7"
                //       : item.status === "Declined"
                //         ? "#f1b5b5"
                //         : item.status === "Cancelled"
                //           ? "#EDB271"
                //           : item.status === "Unapproved"
                //             ? "#ff3628"
                //             : "#dddd8b",
                // })}




                isLoading={this.state.isTableLoading}
                tableCount={filteredAndSortedLeave.length}
                colNameToShow={[
                  "select",
                  "firstName",
                  "leaveType",
                  "date_range",
                  "no_of_days",
                  "ticket_mesasge",
                  "status",

                  "created_at",
                  "updated_at",
                  "actions",
                ]}
                openPopUp={false}
                removeRow={this.removeLeaves}
                actionBtns={ls("roles") === "Employee"
                  ? filteredAndSortedLeave.some((item) => item.status === "Pending" && item.user_id === userId)
                    ? [permissions.includes("Leaveticket.Declined") && ""]
                    : []
                  : []
                }
                bottomBarClassName="leave-ticket-bottom-bar"
                bottomBarContent={
                  (permissions.includes("Leaveticket.Bulkapprove") || permissions.includes("Leaveticket.Bulkdecline") || permissions.includes("Leaveticket.Bulkcancel")) ? (
                    <div className="leave-ticket-bulk-actions">
                      <Select
                        value={this.state.selectedBulkAction}
                        onChange={this.handleBulkActionChange}
                        style={{ marginRight: "10px", minWidth: "150px" }}
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>Select Bulk Action</em>
                        </MenuItem>
                        {permissions.includes("Leaveticket.Bulkapprove") && (
                          <MenuItem value="approve">Bulk Approve</MenuItem>
                        )}
                        {permissions.includes("Leaveticket.Bulkdecline") && (
                          <MenuItem value="decline">Bulk Decline</MenuItem>
                        )}
                        {permissions.includes("Leaveticket.Bulkcancel") && (
                          <MenuItem value="cancel">Bulk Cancel</MenuItem>
                        )}
                      </Select>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleBulkActionGo}
                        disabled={this.state.selectedTickets.length === 0 || !this.state.selectedBulkAction}
                      >
                        Go
                      </Button>
                    </div>
                  ) : (
                    <div />
                  )
                }
                modelName={"Leaves Tickets"}
                updateRoute={"/leave-tickets/edit"}
                openPopUpUpdate={false}
                noDataMessage="No rows found"
              />

              {this.state.showApprovedDetailsPopup && (
                <Dialog
                  open={this.state.showApprovedDetailsPopup}
                  onClose={() => this.setState({ showApprovedDetailsPopup: false })}
                  maxWidth="md"
                  fullWidth
                  PaperProps={{
                    style: {
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                      width: "600px",
                      height: "360px"
                    },
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <DialogTitle
                      style={{
                        textAlign: "center",
                        padding: "5px 0",
                        backgroundColor: "#036dda",
                        color: "#fff",
                        borderTopLeftRadius: "8px",
                        borderTopRightRadius: "8px",
                      }}
                    >
                      Leave Details
                      <CloseIcon
                        style={{
                          position: "absolute",
                          top: 10,
                          right: 10,
                          cursor: "pointer",
                          color: "#fff",
                          backgroundColor: "#f44336",
                          borderRadius: "50%",
                          padding: "2px",
                        }}
                        onClick={() => this.setState({ showApprovedDetailsPopup: false })}
                      />
                    </DialogTitle>
                    <DialogContent>
                      {this.state.selectedLeaveDetails && (
                        <>
                          {console.log(this.state.selectedLeaveDetails)}
                          <div>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                              <tbody>
                                <tr>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Name</b></td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{this.state.selectedLeaveDetails.firstName}</td>
                                </tr>
                                <tr>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Leave Type</b></td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{this.state.selectedLeaveDetails.leaveType}</td>
                                </tr>
                                <tr>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Created On</b></td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{this.state.selectedLeaveDetails.created_at}</td>
                                </tr>
                                <tr>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Reason for Leave</b></td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                                    {this.state.selectedLeaveDetails.ticket_mesasge ? (
                                      <>
                                        {this.state.isReasonExpanded || this.state.selectedLeaveDetails.ticket_mesasge.length <= 50
                                          ? this.state.selectedLeaveDetails.ticket_mesasge
                                          : `${this.state.selectedLeaveDetails.ticket_mesasge.substring(0, 50)}...`}
                                        {this.state.selectedLeaveDetails.ticket_mesasge.length > 50 && (
                                          <span
                                            onClick={() => this.setState({ isReasonExpanded: !this.state.isReasonExpanded })}
                                            style={{ color: '#036dda', cursor: 'pointer', marginLeft: '5px', display: 'inline-block' }}
                                          >
                                            {this.state.isReasonExpanded ? 'Read Less' : 'Read More'}
                                          </span>
                                        )}
                                      </>
                                    ) : 'N/A'}
                                  </td>
                                </tr>
                                {this.state.selectedLeaveDetails.cancel_reason && (
                                  <tr>
                                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Reason for Declined</b></td>
                                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{this.state.selectedLeaveDetails.cancel_reason}</td>
                                  </tr>
                                )}
                                {this.state.selectedLeaveDetails.c_reason && (
                                  <tr>
                                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Reason for Cancelled</b></td>
                                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{this.state.selectedLeaveDetails.c_reason}</td>
                                  </tr>
                                )}
                                <tr>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Date Range</b></td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", whiteSpace: "nowrap" }}>
                                    {(() => {
                                      const dateRange = this.state.selectedLeaveDetails.date_range;
                                      let startDate, endDate;

                                      if (dateRange.includes(' to ')) {
                                        [startDate, endDate] = dateRange.split(' to ');
                                      } else {
                                        [startDate, endDate] = dateRange.split(' To ');
                                      }

                                      const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
                                      return `${startDate} (${capitalize(this.state.selectedLeaveDetails.firstleavetype)}) To ${endDate} (${capitalize(this.state.selectedLeaveDetails.secondleavetype)})`;
                                    })()}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>No Of Days</b></td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{this.state.selectedLeaveDetails.no_of_days}</td>
                                </tr>
                                <tr>
                                  <td style={{ padding: "8px", }}><b>Status</b></td>
                                  <td style={{ padding: "8px", textAlign: "center" }}>:</td>
                                  <td style={{ padding: "8px", }}>{this.state.selectedLeaveDetails.status}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          {isAdmin && this.state.selectedLeaveDetails.status === "Pending" && (
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                cursor: "pointer",
                                margin: "5px"
                              }}
                            >
                              <Tooltip title="Approve">
                                <Button
                                  onClick={() => {
                                    this.updateLeaveStatus(
                                      this.state.selectedLeaveDetails.id,
                                      "Approved"
                                    );
                                    this.setState({ showApprovedDetailsPopup: false });
                                  }}
                                  variant="contained"
                                  color="primary"
                                  className="common-action-button"
                                  style={{ margin: "5px", textTransform: "none" }}
                                >
                                  Approve
                                </Button>
                              </Tooltip>
                              <Tooltip title="Declined">
                                <Button
                                  onClick={() => {
                                    this.updateLeaveStatus(
                                      this.state.selectedLeaveDetails.id,
                                      "Declined"
                                    );
                                    this.setState({ showApprovedDetailsPopup: false });
                                  }}
                                  variant="contained"
                                  style={{ margin: "5px", textTransform: "none", backgroundColor: "#db3535", color: "#ffffff" }}
                                >
                                  Declined
                                </Button>
                              </Tooltip>
                            </div>
                          )}
                        </>
                      )}
                    </DialogContent>
                  </div>
                </Dialog>
              )}

              {this.state.loading && (
                <div className="loading-spinner">
                  <CircularProgress />
                </div>
              )}
            </div>
          }
        />
        <Footer {...this.props} />
      </div>
    );
  }
}

export default withRouter(Ticket);

